//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { getCurrentUser } from 'aws-amplify/auth';
import SentryWrap from "components/Sentry";
import React, { useEffect, useMemo, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { filter, find, cloneDeep, groupBy, get } from "lodash";
//  -- Constants ----------------------
import COLOR from "utils/constants/color";

//  -- Features -----------------------

//  -- Thunks -------------------------

import { Select, Space, Dropdown } from 'antd';
import { isEmpty } from 'lodash';
import moment from "moment-timezone";
import { handleListApExamDataByConfig } from "store/apexams/thunks";
import { handleGetFilterData, handleListGetSchool } from "store/organizations/thunks";
import { handleListDistTeacher, handleListDistUsers } from "store/users/thunks";
import { handleListCourseInfo } from "store/standardexams";
import ExamTableForDistrict from "./ApExamTable";
import Loading from "components/Loading";
import { DownloadOutlined, CaretDownOutlined } from '@ant-design/icons';
import { saveAs } from "file-saver";
import * as Sentry from '@sentry/react';

const ACIFL_LEVEL = ['Score 5 ', 'Score 4', 'Score 3', 'Score 2', 'Score 1']
const EXAM_LABELS_FULL = ['Reading Only', 'Reading and Listening', 'Listening Only', 'Email Response', 'Essay (Argumentative)', 'Simulated Conversation', 'Cultural Comparison']
const MAX_POINTS = [30, 17, 18, 5, 5, 5, 5]

const years = new Date().getFullYear();
const upcomming_year = `${years}-${years + 1}`;
const downcomming_year = `${years - 1}-${years}`;
const { Option } = Select;


const SORTING_ORDER = [
  { value: 'district', label: 'District' },
  { value: 'school', label: 'Schools' },
  { value: 'teacher', label: 'Teacher' },
]
//  ----------------------------------------------------------------------------
//  Styles
//  ----------------------------------------------------------------------------

const DownButton = styled.button`
    border: none;
    cursor: pointer;
    outline: none;
    transition: all 300ms ease;
    margin-right: 16px;
    height: 40px;
    background: ${COLOR.green200};
    color: #fff;
    padding-left: 12px;
    padding-right: 12px;
    &:hover {
      background: ${COLOR.green1000};
    }
`;

const Wrapper = styled.div`
  height: 100%;
  padding: 20px 0px;
  width: 100%;
`;

const MenuWrapper = styled.div`
  display: flex;
  flex-direction: row;
//   justify-content: space-between;
  width: 100%;
  min-height: 80px;
  border-radius: 12px;
//   border: 2px solid ${COLOR.black100};
//   background-color: ${COLOR.blueish400};
  margin-top: ${(p) => (p.top ? p.top : "50px")};
  align-items: center;
  position: relative;
  padding: 2px 0px;
  flex-wrap: wrap;
`;
const MenuBtn = styled.button`
  background-color:white;
  border-top:none;
  border-left:none;
  border-right:none;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  outline: none;
  transition: all 300ms ease;
  padding: 2px 16px 10px 16px;
  min-width: 150px;
  margin-right: 2px;
  margin-left: 2px;
  @media (max-width: 992px) {
    margin-top: 10px;
  }
`;


const VideoContainer = styled.div`
  height: auto;
  flex: 1;
  justify-content: center;
`;

const OverviewText = styled.span`
  color: black;
  font-size: 19px;
  font-weight: 600;
  display:flex !important;
  align-items:center;
`;


const StyledSelect = styled(Select)`
  .ant-select-selector {
    border-radius: 0px !important;
    border: 1px solid #d9d9d9 !important; 
    background-color: rgb(237 237 237) !important;
    height: 40px !important;
    text-align: center;
    justify-content: center;
    align-items: center;
    cursor: pointer !important;
  }
  .ant-select-dropdown {
   
  } 
`;
//  ----------------------------------------------------------------------------
//  Container
//  ----------------------------------------------------------------------------
//
//  Not found container
//
//  -- Description
//  Failed route catch container
//
//  -- Props
//  ...
//
//  -- State
//  ...
//
//  -- Methods
//  ...
//
//  -- Usage
//  ...
//
const ResponsiveContainer = styled(Space)`
  display: flex;
  flex-direction: row; 
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const SELECT_WIDTH = 200;

const SortingMenu = ({
  classData,
  onFilter,
  selected_class,
  disabled = false
}) => {
  const [selectedClass, setSelectedClass] = useState(null)
  useEffect(() => {
    setSelectedClass(selected_class)
  }, [selected_class])

  const onSelectCh = (txt) => {
    if (disabled) return;
    setSelectedClass(txt)
    onFilter(txt)
  }
  return (<div>
    <label htmlFor="schoolSelect" style={{ display: 'block', }}>
      Classes
    </label>
    <StyledSelect
      className="apExamSelect"
      showSearch
      bordered={false}
      placeholder={disabled ? "All selected" : "Select classes"}
      style={{ width: SELECT_WIDTH }}
      value={selectedClass}
      disabled={disabled}
      onChange={onSelectCh}
      options={classData}
      filterOption={(input, option) =>
        option.label.toLowerCase().includes(input.toLowerCase())
      }
    /></div>)
}

const Litracy = ({
  currentOrg,
  schools,
  users,
  distTeacher,
  distStudents
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loadingData, setLoadingData] = useState(false);
  const [teachers, setTeachers] = useState([]);
  const [activeSession, setActiveSession] = useState(null)
  const [resultData, setResultData] = useState({
    question_length: [],
    grades: []
  })
  const [resultDataCombine, setResultDataCombine] = useState({
    question_length: [{
      exam1: '',
      exam2: '',
      exam3: ''
    }],
    grades: [
      {
        user: {},
        submissions: [{
          exam1: '',
          exam2: '',
          exam3: ''
        }]
      }
    ]
  })
  const [selected_teacher, setSelectedTeacher] = useState(null);
  const [selected_school, setSelectedSchool] = useState(null);
  const [selected_class, setSelectedClass] = useState(null);
  const [selected_course, setSelectedCourse] = useState(null);
  const [selectedOrgTeacher, setSelectedOrgTeacher] = useState([])
  const [selectedTeacherClasses, setSelectedTeacherClasses] = useState([])
  const [filterLoader, setFilterLoader] = useState(false)
  const [allCourses, setAllCourses] = useState([]);
  const [courseInfo, setCourseInfo] = useState([]);
  const [selectedCourseForAll, setSelectedCourseForAll] = useState(null);
  const [allCourseClasses, setAllCourseClasses] = useState([]);
  const [examTab, setExamTab] = useState('exam1')
  const [printloader, setPrintloader] = useState(false)
  useEffect(() => {
    if (moment().get("month") < 7) {
      setActiveSession(downcomming_year)
    } else {
      setActiveSession(upcomming_year)
    }
  }, [])
  useEffect(() => {
    if (Array.isArray(users)) {
      setTeachers(filter(distTeacher, ['role', 'teacher']))
    }
  }, [distStudents, distTeacher])

  useEffect(() => {
    const fetchCourseInfo = async () => {
      if (currentOrg?.id) {
        try {
          const result = await dispatch(handleListCourseInfo({ organisationId: currentOrg.id }));
          if (result?.data) {
            setCourseInfo(result.data);
          }
        } catch (error) {
          Sentry.captureException(`Error fetching course info: ${error}`);
        }
      }
    };
    fetchCourseInfo();
  }, [currentOrg, dispatch]);

  useEffect(() => {
    async function fetchData() {
      try {
        await getCurrentUser();
      } catch {
        navigate("/");
      }
    }
    fetchData();
  }, []);
  async function fetchApData(session, tab, teacher_id, school_id) {
    if (selected_school === 'All') {
      if (!selectedCourseForAll) return null;
    } else {
      if (!teacher_id || !school_id || !selected_class) return null;
    }
    let exmtb = getExamValue(tab ? tab : examTab);
    setLoadingData(true);
    if (exmtb != 'combine') {
      let cnf;
      if (selected_school === 'All' && selectedCourseForAll) {
        cnf = {
          "session": session,
          "exam_type": exmtb,
          "school_id": null,
          "teacher_id": null,
          "class_id": null,
          "course_id": selectedCourseForAll,
          "id": currentOrg.id
        }
      } else {
        cnf = {
          "session": session,
          "exam_type": exmtb,
          "teacher_id": teacher_id,
          "school_id": school_id,
          "class_id": selected_class,
          "id": currentOrg.id
        }
      }
      const data = await dispatch(handleListApExamDataByConfig(cnf));
      if (data && data.question_length) {
        setResultData({
          question_length: data.question_length || [],
          grades: data.grades || [],
        })
      }
    } else {
      await onFilterFetchResultCombine(session, teacher_id, school_id)
    }
    setLoadingData(false);
  }

  useEffect(() => {
    if (activeSession) {
      if (selected_school === 'All') {
        if (selectedCourseForAll) {
          fetchApData(activeSession, examTab, selected_teacher, selected_school);
        }
      } else if (selected_school && selected_teacher && selected_class) {
        fetchApData(activeSession, examTab, selected_teacher, selected_school);
      }
    }
  }, [activeSession, selected_school, examTab, selected_teacher, selected_class, selectedCourseForAll]);
  useEffect(() => {
    fetchDistrictData()
  }, [currentOrg]);

  const fetchDistrictData = async () => {
    try {
      if (!isEmpty(currentOrg)) {
        dispatch(handleListGetSchool(currentOrg.id));
        dispatch(handleListDistUsers(currentOrg.id));
        dispatch(handleListDistTeacher(currentOrg.id));
      }
    } catch (error) {
      Sentry.captureException(`462 Error in fetchDistrictData: ${error}`);
    }
  };


  const onExamTabClick = (txt) => {
    setExamTab(txt)
  }

  function combinePlaceholderTxt(txt) {
    switch (txt) {
      case 'NOT ASSIGNED':
        return 'NA'
      case 'NOT STARTED':
        return 'NS'
      case 'NOT FINISHED':
        return 'NF'
      default:
        break;
    }
    return txt;
  }
  async function onFilterFetchResultCombine(session, teacher_id, school_id) {
    if (selected_school === 'All') {
      if (!selectedCourseForAll) return null;
    } else {
      if(!school_id || !teacher_id || !selected_class) return null;
    }
    try {
      setLoadingData(true);
      const examTypes = [1, 2, 3];
      let dataExams;
      
      if (selected_school === 'All' && selectedCourseForAll) {
        dataExams = await Promise.all(examTypes.map(exam_type =>
          dispatch(handleListApExamDataByConfig({
            "session": session,
            "exam_type": exam_type,
            "school_id": null,
            "teacher_id": null,
            "class_id": null,
            "course_id": selectedCourseForAll,
            "id": currentOrg.id
          }))
        ));
      } else {
        dataExams = await Promise.all(examTypes.map(exam_type =>
          dispatch(handleListApExamDataByConfig({
            "session": session,
            "exam_type": exam_type,
            "teacher_id": teacher_id,
            "school_id": school_id,
            "class_id": selected_class,
            "id": currentOrg.id
          }))
        ));
      }

      if (dataExams[0]?.question_length) {
        const question_length = dataExams[0].question_length.map((_, i) => ({
          exam1: dataExams[0].question_length[i],
          exam2: dataExams[1].question_length[i],
          exam3: dataExams[2].question_length[i],
        }));

        const grades = dataExams[0].grades.map(({ user, submissions }) => ({
          user,
          submissions: submissions.map((_, i) => {
            const exam1Sub = find(dataExams[0].grades, ['user.id', user.id]);
            const exam2Sub = find(dataExams[1].grades, ['user.id', user.id]);
            const exam3Sub = find(dataExams[2].grades, ['user.id', user.id]);

            const exam1Txt = exam1Sub?.submissions?.[i] || '';
            const exam2Txt = exam2Sub?.submissions?.[i] || '';
            const exam3Txt = exam3Sub?.submissions?.[i] || '';

            return {
              exam1: i === 0 ? combinePlaceholderTxt(exam1Txt) : exam1Txt,
              exam2: i === 0 ? combinePlaceholderTxt(exam2Txt) : exam2Txt,
              exam3: i === 0 ? combinePlaceholderTxt(exam3Txt) : exam3Txt,
            };
          }),
        }));

        setResultDataCombine({ question_length, grades });
      }
    } catch (error) {
      Sentry.captureException(`463 Error in onFilterFetchResultCombine: ${error}`);
      console.error(error, "error in data compose");
    } finally {
      setLoadingData(false);
    }
  }

  const getExamValue = (key) => {
    const examMap = { exam1: 1, exam2: 2, exam3: 3, combine: 'combine', '1': 1, '2': 2, '3': 3 };
    return examMap[key] || 'combine';
  };


  // const fetchResult = async (type, item_id) => {
  //   if (type === 'school') {
  //     if (examTab !== 'combine') {
  //       fetchApData(activeSession, examTab, null, item_id);
  //     } else {
  //       onFilterFetchResultCombine(activeSession, null, item_id);
  //     }

  //   } else if (type === 'teacher') {
  //     if (examTab !== 'combine') {
  //       fetchApData(activeSession, examTab, item_id, selected_school);
  //     } else {
  //       onFilterFetchResultCombine(activeSession, item_id, selected_school);
  //     }

  //   }
  // };
  const school_option = useMemo(() => {
    const values = [{ label: 'All', value: 'All' }]
    if (!isEmpty(schools)) {
      values.push(...schools.filter(k=>!k.demo).map(v => ({ label: v.displayName, value: v.id })))
    }
    return values;
  }, [schools])

  const fetchTeacherClasses = async (teacher_id) => {
    setSelectedTeacherClasses([])
    setSelectedClass(null)
    setSelectedCourse(null)
    try {
      setFilterLoader(true);
      const result = await handleGetFilterData(null, teacher_id, "classes")
      if (result && result.success) {
        const uniqueCourses = result.data?.reduce((acc, curr) => {
          if (!curr.course_info || !curr.course_info.id) {
            const noCourseEntry = acc.find(c => c.value === null);
            if (!noCourseEntry) {
              acc.push({label: 'No Course', value: null, classes:[{id:curr.id, displayName:curr.displayName, code:curr.code}]})
            } else {
              noCourseEntry.classes.push({id:curr.id, displayName:curr.displayName, code:curr.code})
            }
          } else {
            if (!acc.find(c => c.value === curr.course_info.id)) {
              acc.push({label:curr.course_info.title, value:curr.course_info.id, classes:[{id:curr.id, displayName:curr.displayName, code:curr.code}]})
            } else {
              acc.find(c => c.value === curr.course_info.id).classes.push({id:curr.id, displayName:curr.displayName, code:curr.code})
            }
          }
          return acc;
        }, [])
        setAllCourses(uniqueCourses || [])
        
        if (uniqueCourses && uniqueCourses.length > 0) {
          const firstCourse = uniqueCourses[0]
          setSelectedCourse(firstCourse.value)
          const firstClass = firstCourse.classes?.[0]
          if (firstClass) {
            setSelectedClass(firstClass.id)
          }
        } else if (result.data && result.data.length > 0) {
          const s_class = result.data[0]
          if (s_class) {
            setSelectedClass(s_class.id)
          }
        }
        
        const dt = (result.data||[]).map(k=>({label:`${k.displayName ||''}`, value:k.id}))
        setSelectedTeacherClasses(dt|| [])
      }
    } catch (error) {
      Sentry.captureException(`Error fetching teacher classes: ${error}`);
    } finally{
      setFilterLoader(false);
    }
  }

  const fetchTeacher = async (orgId) => {
    setSelectedOrgTeacher([])
    setSelectedTeacherClasses([])
    setSelectedClass(null)
    setSelectedTeacher(null)
    setFilterLoader(true);
    try {
      const result = await handleGetFilterData(orgId, null, "teacher")
      if (result && result.success) {
        const s_teacher = result.data?.[0];
        if (s_teacher) {
          setSelectedTeacher(s_teacher.id)
          await fetchTeacherClasses(s_teacher.id)
        }
        const dt = (result.data||[]).map(k=>({label:`${k.firstName ||''} ${k.lastName ||''}`,value:k.id}))
        setSelectedOrgTeacher(dt)
      }
    } catch (error) {
      Sentry.captureException(`Error fetching school teacher: ${error}`);
    } finally {
      setFilterLoader(false)
    }
  }

  useEffect(() => {
    const opt = school_option[1]
    if (opt && !selected_school) {
      setSelectedSchool(opt.value)
      fetchTeacher(opt.value)
    }
  }, [school_option]);

  const onSchoolSelect = async (v) => {
    if (v === 'All') {
      setSelectedSchool('All');
      setSelectedTeacher(null);
      setSelectedCourse(null);
      setSelectedClass(null);
      setSelectedCourseForAll(null);
      setAllCourseClasses([]);
      setSelectedOrgTeacher([]);
      setSelectedTeacherClasses([]);
    } else {
      setSelectedSchool(v);
      setSelectedTeacher(null);
      setSelectedCourseForAll(null);
      setAllCourseClasses([]);
      await fetchTeacher(v);
    }
  };

  const onCourseSelectForAll = async (courseId) => {
    setSelectedCourseForAll(courseId);
    setSelectedClass(null);
    if (!courseId) {
      setAllCourseClasses([]);
      setResultData({
        question_length:[],
        grades:[]
      });
      setResultDataCombine({
        question_length: [{
          exam1: '',
          exam2: '',
          exam3: ''
        }],
        grades: [
          {
            user: {},
            submissions: [{
              exam1: '',
              exam2: '',
              exam3: ''
            }]
          }
        ]
      });
      return;
    }
    try {
      setFilterLoader(true);
      const result = await dispatch(handleGetFilterData(currentOrg.id, null, "classes"));
      if (result && result.success && result.data) {
        const filteredClasses = result.data.filter(c => {
          if (courseId === null) {
            return !c.course_info || !c.course_info.id;
          }
          return c.course_info?.id === courseId;
        });
        const classIds = filteredClasses.map(c => c.id);
        setAllCourseClasses(classIds);
      }
    } catch (error) {
      Sentry.captureException(`Error fetching classes for course: ${error}`);
    } finally {
      setFilterLoader(false);
    }
  };

  const filteredClassesByCourse = useMemo(() => {
    if (selected_school === 'All') {
      return [];
    }
    if (!selected_course || !allCourses || allCourses.length === 0) {
      return selectedTeacherClasses
    }
    const selectedCourseData = allCourses.find(c => c.value === selected_course)
    if (!selectedCourseData || !selectedCourseData.classes) {
      return selectedTeacherClasses
    }
    return selectedCourseData.classes.map(cls => ({
      label: cls.displayName || '',
      value: cls.id
    }))
  }, [selected_course, allCourses, selectedTeacherClasses, selected_school])
  const exam_data = useMemo(() => {
    if (selected_class === 'all' || !selected_class) {
      return resultData
    } else {
      const v = cloneDeep(resultData);
      v.grades = filter(v.grades, ['user.class_id', selected_class])
      return v;
    }
  }, [selected_class, resultData])
  const exam_data_combine = useMemo(() => {
    if (selected_class === 'all' || !selected_class) {
      return resultDataCombine
    } else {
      const v = cloneDeep(resultDataCombine);
      v.grades = filter(v.grades, ['user.class_id', selected_class])
      return v;
    }
  }, [selected_class, resultDataCombine])

  const generateCSVForCombinedExam = async () => {
    try {
      setPrintloader(true)
      const getHeaderKey = (examKey, index) => {
        switch (index) {
          case 0:
            return `${examKey} Placement`;
          case 1:
            return `${examKey} Reading Only`;
          case 2:
            return `${examKey} Reading and Listening`;
          case 3:
            return `${examKey} Listening Only`;
          case 4:
            return `${examKey} Email Response`;
          case 5:
            return `${examKey} Essay (Argumentative)`;
          case 6:
            return `${examKey} Simulated Conversation`;
          case 7:
            return `${examKey} Cultural Comparison`;
          default:
            return `${examKey} Q${index}`;
        }
      };

      const uniqueRows = new Set();
      const headers = ['Name', 'Username'];
      exam_data_combine.question_length.forEach((question, index) => {
        Object.entries(question).forEach(([examKey, questionValue]) => {
          headers.push(getHeaderKey(examKey, index));
        });
      });

      const questionsRow = {
        Name: 'Questions per section:',
        Username: '',
        ...exam_data_combine.question_length.reduce((acc, question, index) => {
          Object.entries(question).forEach(([examKey, questionValue]) => {
            const headerKey = getHeaderKey(examKey, index);
            acc[headerKey] = index === 0 ? '' : questionValue;
          });
          return acc;
        }, {})
      };
      uniqueRows.add(questionsRow);

      const maxPointsRow = {
        Name: 'Max possible points:',
        Username: '',
        ...exam_data_combine.question_length.reduce((acc, question, index) => {
          Object.entries(question).forEach(([examKey, questionValue]) => {
            const headerKey = getHeaderKey(examKey, index);
            acc[headerKey] = index === 0 ? '' : MAX_POINTS[index - 1];
          });
          return acc;
        }, {})
      };
      uniqueRows.add(maxPointsRow);

      exam_data_combine.grades.forEach(({ user, submissions }) => {
        const rowData = {
          Name: `${user.lastName || ""}, ${user.firstName || ""}`,
          Username: user.username,
          ...submissions.reduce((acc, submission, index) => {
            Object.entries(submission).forEach(([examKey, value]) => {
              const headerKey = getHeaderKey(examKey, index);
              acc[headerKey] = value;
            });
            return acc;
          }, {})
        };
        uniqueRows.add(rowData);
      });

      const finalData = Array.from(uniqueRows);
      const ExcelJS = (await import('exceljs')).default;
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Combined Proficiency');
      worksheet.addRow(headers);
      finalData.forEach(row => {
        worksheet.addRow(headers.map(header => row[header] || '-'));
      });

      const borderThin = {
        top: { style: 'thin', color: { argb: 'FF000000' } },
        bottom: { style: 'thin', color: { argb: 'FF000000' } },
        left: { style: 'thin', color: { argb: 'FF000000' } },
        right: { style: 'thin', color: { argb: 'FF000000' } }
      };
      const headerRow = worksheet.getRow(1);
      headerRow.eachCell((cell) => {
        cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF02796D' } };
        cell.border = borderThin;
        cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
      });
      [2, 3].forEach((rn) => {
        worksheet.getRow(rn).eachCell((cell, colNumber) => {
          cell.border = borderThin;
          cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD9EAD3' } };
          cell.alignment = { vertical: 'middle', horizontal: 'center' };
          if (rn === 2 && colNumber === 1) cell.font = { bold: true };
          if (rn === 3 && colNumber === 1) cell.font = { bold: true };
        });
      });
      worksheet.eachRow((row, rowNumber) => {
        if (rowNumber >= 4) {
          const fillArgb = (rowNumber - 4) % 2 === 0 ? 'FFFFFFFF' : 'FFF5F5F5';
          row.eachCell((cell) => {
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: fillArgb } };
            cell.border = borderThin;
          });
        }
      });

      worksheet.columns.forEach((col) => {
        let maxLength = 10;
        col.eachCell({ includeEmpty: true }, (cell) => {
          const val = cell.value ? cell.value.toString() : '';
          maxLength = Math.max(maxLength, val.length);
        });
        col.width = maxLength + 2;
      });
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      saveAs(blob, `combined_proficiency ${moment().format("DD-MM-YY hh:mm:ss")}.xlsx`);
    } catch (error) {
      Sentry.captureException(`464 Error in combined exam gradebook download: ${error}`);
      console.error("Error in combined exam gradebook download:", error);
    } finally {
      setPrintloader(false);
    }
  };

  const generateCSV = async () => {
    if (examTab === "combined") {
      await generateCSVForCombinedExam();
      return;
    }

    try {
      setPrintloader(true);

      const questionsRow = [
        'Questions per section:',
        '',
        '',
        '',
        '',
        exam_data.question_length[0],
        '',
        '',
        '',
      ];

      EXAM_LABELS_FULL.forEach((label, i) => {
        questionsRow.push(exam_data.question_length[i + 1]);
      });

      const maxPointsRow = [
        'Max possible points:',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
      ];

      EXAM_LABELS_FULL.forEach((label, i) => {
        maxPointsRow.push(MAX_POINTS[i]);
      });

      const firstHeaderRow = [
        'Name',
        'Username',
        'Student Id',
        'Teacher Name',
        'School Name',
        'Placement',
        'Overall',
        '',
        '',
      ];

      EXAM_LABELS_FULL.forEach((label, i) => {
        firstHeaderRow.push(label);
      });

      const secondHeaderRow = [
        '',
        '',
        '',
        '',
        '',
        '',
        'Overall score',
        'Overall Points possible',
        'Overall Points earned',
      ];

      EXAM_LABELS_FULL.forEach(() => {
        secondHeaderRow.push('');
      });

      const dataRows = [];
      exam_data.grades.forEach(({ user, submissions, categoryValues, overallPoints, maxPoints, overallScore }) => {
        const row = [
          `${user.lastName || ""}, ${user.firstName || ""}`,
          user.username || '',
          user.studentId || '',
          user.teacherName || '',
          user.schoolName || '',
          submissions[0] || '-',
          overallScore !== null && overallScore !== undefined ? overallScore : '-',
          maxPoints !== null && maxPoints !== undefined ? maxPoints : '-',
          overallPoints !== null && overallPoints !== undefined ? overallPoints : '-',
        ];

        EXAM_LABELS_FULL.forEach((label, i) => {
          const sectionGrade = submissions[i + 1] || '-';
          row.push(sectionGrade);
        });

        dataRows.push(row);
      });

      const groupdata = groupBy(exam_data.grades, ({ submissions }) => submissions[0])
      const extraData = ACIFL_LEVEL.reduce((acc, type) => {
        const t_val = type.split(" ")[1].trim();
        const sub = get(groupdata[t_val], "length", 0) || 0;
        acc[type] = sub;
        return acc;
      }, {});

      const ExcelJS = (await import('exceljs')).default;
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('ap_exam');

      worksheet.addRow(Object.keys(extraData));
      worksheet.addRow(Object.values(extraData));
      worksheet.addRow([]);

      worksheet.addRow(firstHeaderRow);
      worksheet.addRow(questionsRow);
      worksheet.addRow(maxPointsRow);
      worksheet.addRow(secondHeaderRow);

      dataRows.forEach((row) => {
        worksheet.addRow(row);
      });

      worksheet.mergeCells(4, 7, 4, 9);

      const placementColCount = Object.keys(extraData).length;
      const columnCount = firstHeaderRow.length;
      const borderThin = {
        top: { style: 'thin', color: { argb: 'FF000000' } },
        bottom: { style: 'thin', color: { argb: 'FF000000' } },
        left: { style: 'thin', color: { argb: 'FF000000' } },
        right: { style: 'thin', color: { argb: 'FF000000' } }
      };

      for (let rowIndex = 1; rowIndex <= worksheet.rowCount; rowIndex++) {
        if (rowIndex === 1 || rowIndex === 4 || rowIndex === 7) {
          worksheet.getRow(rowIndex).height = 35;
        }
        if (rowIndex === 1 || rowIndex === 2) {
          for (let colIndex = 1; colIndex <= placementColCount; colIndex++) {
            const cell = worksheet.getCell(rowIndex, colIndex);
            cell.border = borderThin;
            cell.alignment = { vertical: 'middle', horizontal: 'center', indent: rowIndex === 1 ? 1 : 0 };
            if (rowIndex === 1) {
              cell.font = { bold: true };
            }
            if (colIndex % 2 === 0) {
              cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFF5F5F5' } };
            }
          }
        }
        if (rowIndex === 3) continue;
        if (rowIndex >= 4 && rowIndex <= 6) {
          for (let colIndex = 1; colIndex <= columnCount; colIndex++) {
            const cell = worksheet.getCell(rowIndex, colIndex);
            if (rowIndex === 4 || colIndex === 1) {
              cell.font = { bold: true };
            }
            cell.border = borderThin;
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD9EAD3' } };
            cell.alignment = { vertical: 'middle', horizontal: 'center' };
          }
        }
        if (rowIndex === 7) {
          for (let colIndex = 1; colIndex <= columnCount; colIndex++) {
            const cell = worksheet.getCell(rowIndex, colIndex);
            cell.font = { bold: true };
            cell.border = borderThin;
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD9EAF7' } };
            cell.alignment = { vertical: 'middle', horizontal: 'center' };
          }
        }
        const fillColor = (rowIndex - 8) % 2 === 0 ? 'FFFFFFFF' : 'FFF5F5F5';
        if (rowIndex >= 8) {
          for (let colIndex = 1; colIndex <= columnCount; colIndex++) {
            const cell = worksheet.getRow(rowIndex).getCell(colIndex);
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: fillColor } };
            cell.border = borderThin;
          }
        }
      }

      worksheet.columns.forEach((col) => {
        let maxLength = 10;
        col.eachCell({ includeEmpty: true }, (cell) => {
          const val = cell.value ? cell.value.toString() : '';
          maxLength = Math.max(maxLength, val.length);
        });
        col.width = maxLength + 2;
      });

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      saveAs(blob, `ap_exam ${moment().format("DD-MM-YY hh:mm:ss")}.xlsx`);
    } catch (error) {
      Sentry.captureException(`465 Error in exam gradebook download: ${error}`);
      console.error("Error in exam gradebook download:", error);
    } finally {
      setPrintloader(false);
    }
  };

  const downloadMenuItems = {
    items: [
      {
        key: 'xlsx',
        label: (
          <div onClick={() => generateCSV()}>
            Download as XLSX
          </div>
        ),
      },
      {
        key: 'csv',
        label: (
          <div onClick={() => generateCSV()}>
            Download as CSV
          </div>
        ),
      },
    ]
  };

  return (
    <SentryWrap>
      <Wrapper className={"adminForm adminFormCstm"}>
        <OverviewText>Admin</OverviewText>
        <ResponsiveContainer size="middle" className="inputBoxesCstm">
          <div>
            <label htmlFor="schoolSelect" style={{ display: 'block', }}>
              Schools
            </label>
            <StyledSelect
              className="apExamSelect"
              id="schoolSelect"
              defaultValue={selected_school}
              style={{ width: SELECT_WIDTH }}
              showSearch
              bordered={false}
              value={selected_school}
              placeholder={"Select"}
              options={school_option}
              onChange={onSchoolSelect}
              filterOption={(input, option) =>
                option.label.toLowerCase().includes(input.toLowerCase())
              }
            />
          </div>

          {selected_school === 'All' ? (
            <div>
              <label htmlFor="courseSelectForAll" style={{ display: 'block', }}>
                Courses
              </label>
              <StyledSelect
                className="apExamSelect"
                value={selectedCourseForAll}
                style={{ width: SELECT_WIDTH }}
                showSearch
                filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())}
                options={courseInfo.map(c => ({ label: c.title, value: c.id }))}
                onChange={(v) => {
                  onCourseSelectForAll(v)
                }} 
              />
            </div>
          ) : (
            <>
              <div>
                <label htmlFor="teacherSelect" style={{ display: 'block', }}>
                  Teachers
                </label>
                <StyledSelect
                  className="apExamSelect"
                  defaultValue={'all'}
                  value={selected_teacher}
                  disabled={selected_school === 'All'}
                  style={{ width: SELECT_WIDTH }}
                  showSearch
                  filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())}
                  options={selectedOrgTeacher}
                  onChange={(v) => {
                    setSelectedTeacher(v)
                    fetchTeacherClasses(v)
                  }} />
              </div>

              <div>
                <label htmlFor="courseSelect" style={{ display: 'block', }}>
                  Courses
                </label>
                <StyledSelect
                  className="apExamSelect"
                  defaultValue={'all'}
                  value={selected_course}
                  style={{ width: SELECT_WIDTH }}
                  showSearch
                  filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())}
                  options={allCourses}
                  onChange={(v) => {
                    setSelectedCourse(v);
                    if (v && allCourses) {
                      const selectedCourseData = allCourses.find(c => c.value === v)
                      if (selectedCourseData && selectedCourseData.classes && selectedCourseData.classes.length > 0) {
                        setSelectedClass(selectedCourseData.classes[0].id)
                      } else {
                        setSelectedClass(null)
                      }
                    } else {
                      setSelectedClass(null)
                    }
                  }} 
                />
              </div>
            </>
          )}

          <SortingMenu
            className="apExamSelect"
            classData={filteredClassesByCourse}
            selected_class={selected_class}
            onFilter={(v) => {
              setSelectedClass(v)
            }}
            disabled={selected_school === 'All'}
          />
          <Dropdown menu={downloadMenuItems} placement="bottomLeft" trigger={['click']}>
            <DownButton
              className="apExamSelect"
              type="button"
              onClick={e => e.preventDefault()}
            >
              {printloader ? <Loading size={20} /> : <DownloadOutlined style={{ marginRight: '4px' }} />}
              Download
              <CaretDownOutlined style={{ fontSize: '11px', marginLeft: '6px' }} />
            </DownButton>
          </Dropdown>
        </ResponsiveContainer>

        <ExamTableForDistrict
          dataLoading={loadingData || filterLoader}
          examType={examTab}
          onExamTabClick={onExamTabClick}
          resultData={exam_data}
          activeSession={activeSession}
          resultDataCombine={exam_data_combine}
          setActiveSession={setActiveSession}
        />

      </Wrapper>
    </SentryWrap>
  );
};


//  ----------------------------------------------------------------------------
//  Redux
//  ----------------------------------------------------------------------------
const mapStateToProps = (state) => ({
  currentOrg: state.currentOrg,
  schools: state.schools,
  users: state.users,
  distTeacher: state.distTeacher,
  distStudents: state.distStudents
});

export default connect(mapStateToProps, null)(Litracy);
